import { InclusiveExclusiveModelComparator } from './comparators/inclusive-exclusive-model-comparator';
import {
  InclusiveExclusiveFilterModel,
  IFilterComparator,
  ConfigureOptionsParams,
  FilterOptions,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FilterResultFacade } from '../filter-result-facade';
import { filterInclusiveExclusiveValues } from '../filter-utils';
import { FilterHandlerBase } from './base/filter-handler-base';
import { OptionsType } from '../../issue/maturity';
import { GridFilterUnionModel } from '../filter-types';
import { ISetFilter } from 'ag-grid-community';

export class ManagerFilterHandler extends FilterHandlerBase {
  private comparator: IFilterComparator<InclusiveExclusiveFilterModel>;

  get name(): string {
    return CalendarGridColumnName.Manager;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    const values = [...params.filterOptions.managers].sort(
      (option1, option2) => {
        if (option1 === OptionsType.Blank) {
          return 1;
        }
        if (option2 === OptionsType.Blank) {
          return -1;
        }
        return option1 < option2 ? -1 : 1;
      }
    );

    params.setFilterService.managers = values;

    // Only refresh filter values when we have valid data to display
    if (!values.length) {
      return;
    }

    params.api.getColumnFilterInstance<ISetFilter>(this.name).then((filter) => {
      filter?.refreshFilterValues();
    });
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.managers;
  }

  toStoreFilterModel(
    model: GridFilterUnionModel,
    filterOptions: FilterOptions
  ): GridFilterUnionModel {
    const normalizedModel = {
      ...(model as InclusiveExclusiveFilterModel),
      values: (
        ((model as InclusiveExclusiveFilterModel)?.values || []) as Array<
          string | null
        >
      ).map((value) => value ?? OptionsType.Blank)
    } as InclusiveExclusiveFilterModel;

    return super.toStoreFilterModel(normalizedModel, filterOptions);
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<InclusiveExclusiveFilterModel>,
    store: InclusiveExclusiveFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options
  ): IFilterComparator<InclusiveExclusiveFilterModel> {
    if (!this.comparator) {
      this.comparator = new InclusiveExclusiveModelComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const seniorManager = params.filters[this.name];
    const data = params.deal;
    const filterOptions = params.options;
    let seniorManagerFilterPassed = true;
    if (seniorManager) {
      const model: InclusiveExclusiveFilterModel =
        seniorManager.model as InclusiveExclusiveFilterModel;
      const manager = data.seniorManager
        ? data.seniorManager.shortName || data.seniorManager.name
        : '(Blank)';
      seniorManagerFilterPassed = filterInclusiveExclusiveValues(
        model,
        [manager],
        this.getFilterOptions(filterOptions)
      );
    }
    result.applyDealFilerResult(data.id, this.name, seniorManagerFilterPassed);
    return seniorManagerFilterPassed;
  }
}
